import {AbstractControl} from '@angular/forms';

type PatchableMethod = 'markAsTouched' | 'markAsUntouched' | 'markAllAsTouched';

/**
 * Calls `afterCall` whenever `control[method]` runs, and returns a function that puts the original
 * back - an OnPush CVA has no other way to notice its control was marked (un)touched. Restore from
 * `ngOnDestroy`, or the override outlives the field and stacks one per mount. (AGI-19494)
 */
export function patchControlMethod(
    control: AbstractControl,
    method: PatchableMethod,
    afterCall: () => void,
): () => void {
    const original = control[method].bind(control);
    const patched = (...args: Parameters<typeof original>): void => {
        original(...args);
        afterCall();
    };
    control[method] = patched;

    return () => {
        // Only unwind our own wrapper: another instance may have wrapped ours since (the same
        // control can be bound twice), and it puts ours back on its own destroy.
        if (control[method] === patched) {
            control[method] = original;
        }
    };
}
